/**
 * CheckboxSet component themable props.
 */
import { stringLiteralArray } from "../utils"

export default { appearances: stringLiteralArray(["default"]) }
